module.exports = __webpack_public_path__ + "img/figure-6.b8937015.png";